<template>
  <div class="playlist-container">
    <div
    v-if="playlists.length > 0"
      class="playlist-content"
      v-for="playlist in playlists"
      :key="playlist.id"
    >
      <div class="image-container">
        <img
          :src="playlist.image_portrait"
          :alt="playlist.name"
        />
        <div class="status">
          <span
            class="badge badge--success"
            v-if="playlist.status == 1"
            >Active</span
          >
          <span
            class="badge badge--danger"
            v-else
            >Inactive</span
          >
        </div>
        <div class="description">
          <div
            class="left-side"
            @click.prevent="getPlaylistList(playlist.id)"
          >
            <div class="video-counts">
              <span> <i class="las la-list"></i></span>
              <span class="counts">
                {{ playlist.items.length }} Video{{
                  playlist.items.length >= 2 ? 's' : ''
                }}
              </span>
            </div>
            <span class="item-name">- {{ playlist.name }} </span>
          </div>
        </div>
        <div class="action-container">
          <button
            class="btn btn--primary"
            @click.prevent="getPlaylistList(playlist.id)"
          >
            <i class="las la-list"></i>
          </button>
          <button
            class="btn btn--warning"
            @click.prevent="editPlaylist(playlist.id)"
          >
            <i class="las la-edit"></i>
          </button>
        </div>
      </div>
    </div>

   
  </div>
</template>

<script>
export default {
  name: 'flix-playists',
  props: {
    playlists: {
      type: Array,
      required: true,
    },
  },
  mounted() {},
  methods: {
    getPlaylistList(playlist_id) {
      const url = `${window.location.origin}/creator/flix-playlist/${playlist_id}/details`;
      window.location = url;
    },
    editPlaylist(playlist_id) {
      const url = `${window.location.origin}/creator/flix-playlist/${playlist_id}/edit`;
      window.location = url;
    },
  },
};
</script>

<style scoped>
.playlist-container {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr repeat(2, 1fr);
  grid-template-rows: 1fr repeat(2, 1fr);
  grid-gap: 1rem;
}

@media screen and (max-width: 1024px) {
  .playlist-container {
    grid-template-columns: 1fr repeat(1, 1fr);
    grid-template-rows: 1fr repeat(3, 1fr);
  }
}
@media screen and (min-width: 1440px) {
  .playlist-container {
    grid-template-columns: 1fr repeat(3, 1fr);
    grid-template-rows: 1fr repeat(2, 1fr);
  }
}

@media screen and (min-width: 1920px) {
  .playlist-container {
    grid-template-columns: 1fr repeat(4, 1fr);
    grid-template-rows: 1fr repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .playlist-container {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
  }
}

.playlist-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  position: relative;
  transition: box-shadow 0.3s ease-in-out;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
}
.playlist-content:hover {
  box-shadow: 1px 2px 20px 2px rgb(0 0 0 / 20%);
}

.image-container {
  width: 100%;
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px 5px 0px 5px;
  overflow: hidden;
  position: relative;
  background-color: gray;

  .status {
    position: absolute;
    top: 10px;
    right: 10px;
    backdrop-filter: blur(2px);

    .badge {
      padding: 0.5rem 1rem;
    }
  }
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.action-container {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  top: 40%;
  right: 0;
  transition: opacity 0.3s ease-in-out;
}
.image-container .description {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding: 0 10px;
  backdrop-filter: blur(3px);
}

.image-container .description .left-side {
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: white;
}

.image-container .description .left-side .video-counts {
  font-weight: 900;
  font-size: 13px;
}
.image-container .description .left-side .item-name {
  margin-left: 5px;
}

.image-container .description span {
  color: white;
}
.action-container .btn {
  margin: 0.5rem 0.5rem;
  padding: 0.5rem 0.5rem;
  border-radius: 50%;
  align-items: center;
  display: flex;
}

.action-container .btn i {
  font-size: 20px;
  color: #fff;
  margin: 0;
}
</style>
